module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/es-card-drag.0b1b6c68a8d87e7434e0.gif";